// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CheckShield48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckShield48Filled: FC<CheckShield48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m21.8 30.2 11.4-11.4-2.1-2.05-9.15 9.15-5.05-5.05-2.2 2.2 7.1 7.15ZM24 43.95c-4.667-1.167-8.5-3.875-11.5-8.125S8 26.917 8 21.85V9.95l16-6 16 6v11.9c0 5.067-1.5 9.725-4.5 13.975S28.667 42.783 24 43.95Z" />
        </svg>
    );
};

export default CheckShield48Filled;
